export default "__VITE_ASSET__03132534__"